export const CountStore = {
    state: () => ({
        count: 0,
    }),
    mutations: {
        increment: function(state) {
            state.count++;
        },
    },
    getters: {
        getCount: function(state) {
            return state.count;
        },
    },
    actions: {
        increment: function(context) {
            context.commit('increment');
        },
    },
};
